import {default as defineIntlMessages} from './defineMessages';

export default defineIntlMessages({
        errMsgTitle: 'errMsgTitle',
        errMsgServerError: 'errMsgServerError',
        errMsgUnauthorized: 'errMsgUnauthorized',
        errMsgCheckInExpiredError: 'errMsgCheckInExpiredError',
        errMsgCheckInFutureError: 'errMsgCheckInFutureError',
        errMsgMissingInfoError: 'errMsgMissingInfoError',
        errMsgExceedTextLengthLimitError: 'errMsgExceedTextLengthLimitError',
        loginLoadingText: 'loginLoadingText',
        usernameOrEmailInputLabel: 'usernameOrEmailInputLabel',
        passwordInputLabel: 'passwordInputLabel',
        loginButtonLabel: 'loginButtonLabel',
        logoutButtonLabel: 'logoutButtonLabel',
        profileDataLine1: 'profileDataLine1',
        profileDataLine2: 'profileDataLine2',
        profileDataLine3: 'profileDataLine3',
        profileDataLine4: 'profileDataLine4',
        profileDataLine5: 'profileDataLine5',
        cancelButtonLabel: 'cancelButtonLabel',
        confirmButtonLabel: 'confirmButtonLabel',
        submitButtonLabel: 'submitButtonLabel',
        cancelConfirmButtonLabel: 'cancelConfirmButtonLabel',
        changeLanguageModalTitle: 'changeLanguageModalTitle',
        changeLanguageModalContent: 'changeLanguageModalContent',
        dailyCheckInLabel: 'dailyCheckInLabel',
        learningProgressLabel: 'learningProgressLabel',
        messageBoardLabel: 'messageBoardLabel',
        nameLabel: 'nameLabel',
        emailLabel: 'emailLabel',
        leaveMsgLabel: 'leaveMsgLabel',
        starFieldLabel: 'starFieldLabel',
        msgInputLimitText: 'msgInputLimitText',
        msgContentLimitText: 'msgContentLimitText',
        msgSubmitLimitText: 'msgSubmitLimitText',
        msgSubmittedText: 'msgSubmittedText',
        privateContentText: 'privateContentText',
        checkInDateLabel: 'checkInDateLabel',
        checkInButtonLabel: 'checkInButtonLabel',
        todayCheckedInLabel: 'todayCheckedInLabel',
        checkInNotConfirmedText: 'checkInNotConfirmedText',
        learnChineseCharacterLabel: 'learnChineseCharacterLabel',
            learnNumberLabel: 'learnNumberLabel',
        learnDeutschAlphabetLabel: 'learnDeutschAlphabetLabel',
        learnedChineseCharacterLabel: 'learnedChineseCharacterLabel',
            rememberedChineseCharacterLabel: 'rememberedChineseCharacterLabel',
            learnedGermanAlphabetLabel: 'learnedGermanAlphabetLabel',
            rememberedGermanAlphabetLabel: 'rememberedGermanAlphabetLabel',
        adminLabel: 'adminLabel',
        queryReplyWithMsgIdText: 'queryReplyWithMsgIdText',
        queryReplyLabel: 'queryReplyLabel',
        queryCodeLabel: 'queryCodeLabel',
        queryCodeInfoText: 'queryCodeInfoText',
        queryButtonLabel: 'queryButtonLabel',
        pasteButtonLabel: 'pasteButtonLabel',
        errMsgQueryCodeEmptyError: 'errMsgQueryCodeEmptyError',
        currentHasNoReply: 'currentHasNoReply',
        rememberedButtonLabel: 'rememberedButtonLabel',
            voiceLangSelectLabel: 'voiceLangSelectLabel',
            learnGameLabel: 'learnGameLabel',
            characterOrNumber: 'characterOrNumber',
            charType: 'charType',
            chineseCharacterLabel: 'chineseCharacterLabel',
            alphabetLabel: 'alphabetLabel',
            numberLabel: 'numberLabel',
            errMsgNewCharEmptyError: 'errMsgNewCharEmptyError',
    gamePageInfo: 'gamePageInfo',
        typingGameAdjustSpeed: 'typingGameAdjustSpeed',
        typingGameCurrentScore: 'typingGameCurrentScore',
        gameTime: 'gameTime',
        gameStart: 'gameStart',
        gameTimeLeft: 'gameTimeLeft',
        gameEndScore: 'gameEndScore',
        gameEndEarly: 'gameEndEarly',
        gamePlayAgain: 'gamePlayAgain',
        rocketCountdownGameLabel: 'rocketCountdownGameLabel',
        rocketCountdownGameInfo: 'rocketCountdownGameInfo',
    },
    'maxi-ding'
);